<ng-container *ngIf="office">

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">

                    <div class="smp-title-thin-border mb-3">{{ 'office_management.title.address' | translate }} </div>

                    <div class="row no-gutters mt-1">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.name1 | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.name1}}"
                                       type="text" matInput
                                       [(ngModel)]="office.name1"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.name2 | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.name2}}"
                                       type="text" matInput
                                       [(ngModel)]="office.name2"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.name3 | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.name3}}"
                                       type="text" matInput
                                       [(ngModel)]="office.name3"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.officeCode | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.officeCode}}"
                                       type="text" matInput
                                       [formControl]="office_code"
                                       required>
                                <mat-error *ngIf="office_code.invalid">{{ getOfficeCodeError() | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <address-twb [(bananaBox)]="office.address"></address-twb>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.tax_number | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.tax_number}}"
                                       type="text" matInput
                                       [(ngModel)]="office.tax_number"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.tax_number2 | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.tax_number2}}"
                                       type="text" matInput
                                       [(ngModel)]="office.tax_number2"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ office.trans.commercial_register_number | translate }}</mat-label>
                                <input id="{{idPrefix}}{{office.trans.commercial_register_number}}"
                                       type="text" matInput
                                       [(ngModel)]="office.commercial_register_number"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width mt-3">
                                <mat-label>{{ office.trans.ceo | translate }}</mat-label>
                                <textarea id="{{idPrefix}}{{office.trans.ceo}}"
                                          matInput
                                          rows="2"
                                          [(ngModel)]="ceo"
                                          [disabled]="disabled">
                                </textarea>
                            </mat-form-field>
                        </div>
                    </div>

                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">

            <div class="row">
                <div class="col-sm-10">

                    <div class="smp-title-thin-border mb-3">{{ office.address.trans.contacts | translate }} </div>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">

                    <contacts-twb [idPrefix]="idPrefix"
                                  [(bananaBox)]="office.address.contacts">
                    </contacts-twb>

                </div>
            </div>

        </div>
    </div>

    <div class="row mt-4 mb-5">
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <div class="smp-title-thin-border">{{ 'office_management.title.logo' | translate }} </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12 mt-4">
                            <smp-dropzone [idPrefix]="(idPrefix + 'dropzone_logo.')"
                                          class="full-width"
                                          [label]="'common.btn.browse' | translate"
                                          [addButtonLabel]="'common.btn.browse' | translate"
                                          [acceptedFiles]="signatureAndStampFileTypes"
                                          (filesSelected)="onLogoFilesSelected($event)"
                                          [multi]="false"
                                          [hasContent]="officeMediaContainer?.logo?.entries.length > 0">
                                <file-thumbnails-list [idPrefix]="(idPrefix + 'logo.')"
                                                      [fileMetaList]="officeMediaContainer?.logo"
                                                      [disabledOptions]="disabledImageOptions"
                                                      [withIconAvatars]="true"
                                                      [labelProp]="'description'"
                                                      (delete)="deleteLogo($event)">
                                </file-thumbnails-list>
                            </smp-dropzone>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2">

                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">
                    <div class="smp-title-thin-border">{{ 'office_management.title.meta_graphic' | translate }} </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12 mt-4">
                            <smp-dropzone [idPrefix]="(idPrefix + 'dropzone_graphic.')"
                                          class="full-width"
                                          [label]="'common.btn.browse' | translate"
                                          [addButtonLabel]="'common.btn.browse' | translate"
                                          [acceptedFiles]="signatureAndStampFileTypes"
                                          (filesSelected)="onMetaGraphicFilesSelected($event)"
                                          [hasContent]="officeMediaContainer?.metagraphic?.entries.length > 0">
                                <file-operation-list [idPrefix]="(idPrefix + 'graphic.')"
                                                     [fileMetaList]="officeMediaContainer?.metagraphic"
                                                     [disabledOptions]="disabledImageOptions"
                                                     [withIconAvatars]="true"
                                                     (delete)="deleteMetaGraphic($event)">
                                </file-operation-list>
                            </smp-dropzone>
                        </div>
                    </div>

                </div>
                <div class="col-sm-2">

                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm-10 col-md-11">
            <div class="smp-title-thin-border">{{ 'office_management.title.bank_details' | translate }} </div>
        </div>

        <banks-twb class="full-width"
                   [idPrefix]="idPrefix"
                   [(bananaBox)]="office.bankDetails"
                   [bankCol]="'col-md-6 col-sm-12'"
                   [multi]="true">
        </banks-twb>
    </div>

    <div class="row mt-5">
        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <a id="{{idPrefix}}btn.cancel"
               mat-stroked-button
               color="primary"
               class="full-width"
               (click)="cancel()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <button id="{{idPrefix}}btn.save"
                    mat-flat-button
                    color="accent"
                    class="full-width"
                    (click)="submit()">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>
    </div>

</ng-container>
